import { Routes } from '@angular/router';

//Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

export const CONTENT_ROUTES: Routes = [
  {
    path: 'no-auth',
    loadChildren: () => import('../../app-okc/no-auth/no-auth.module').then(m => m.NoAuthModule)
  }
];